module.exports = __webpack_public_path__ + "static/usage_scan_code-f5a8bd8c407a0539b155d140ad945981.jpg";